export interface Origin {
  id: string;
  name: string;
  epithet: string;     // a sub-line under the name, e.g. "Hidalgo of Castile"
  seal: string;        // single unicode glyph used in the wax-seal on the card
  blurb: string;
  startingReales: number;
  bonusText: string;
}

export const ORIGINS: Origin[] = [
  {
    id: 'noble',
    name: 'Noble',
    epithet: 'Of an Old House',
    seal: '♔',
    blurb: 'A second son of an old house with too much pride and a letter from the Crown. The voyage was your idea; the bills will be paid in your father\'s name.',
    startingReales: 5000,
    bonusText: 'Crew respects your authority. +Morale.',
  },
  {
    id: 'sailor',
    name: 'Veteran Sailor',
    epithet: 'Master Mariner',
    seal: '⚓',
    blurb: 'Forty years before the mast. You\'ve been wrecked twice, marooned once, and you know every knot on a ship. Your purse is light but your hands are not.',
    startingReales: 1500,
    bonusText: 'Sea-hardened. +Sailing skill, +Morale.',
  },
  {
    id: 'buccaneer',
    name: 'Penniless Buccaneer',
    epithet: 'Brother of the Coast',
    seal: '☠',
    blurb: 'You arrived at the dock with a borrowed cutlass and the smell of three taverns on your coat. You have nothing to lose and you have plans for that.',
    startingReales: 500,
    bonusText: 'Tough as leather. +Combat, +Scurvy resistance.',
  },
];

export function getOrigin(id: string): Origin | undefined {
  return ORIGINS.find(o => o.id === id);
}
